import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { canOpenPlansPage } from '../../utils/isProfessional';

/**
 * Gate for the advertiser-subscriptions (/membership) page.
 *
 * Subscriptions are broker/company quota plans — individuals don't subscribe
 * (they list one-off under the platform FAL). Logged-out visitors may still
 * view the page (marketing for prospective brokers); a logged-in individual is
 * redirected to the add-ons that actually help them.
 */
export default function AdvertiserRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  // Advertisers are brokers, companies and staff (utils/isProfessional, the same
  // rule the links to this page use).
  if (user && !canOpenPlansPage(user)) return <Navigate to="/addons" replace />;

  return <>{children}</>;
}
